"use strict";

jQuery.fn.typeahead = function (userOptions) {
	var MAX_ROWS = 20,
	    input = this,
	    cnt = userOptions.cnt || div({}, {}),
	    list = $('<ul></ul>'),
	    timeout,
	    moreNav,
	    call = function call() {
		var val = input.val(),
		    url = userOptions.replace(userOptions.url, val);
		$.getJSON(url, function (result) {
			fillList(result);
		}).fail(function () {});
	},
	    clear = function clear() {
		$('.iChart-dpMenu-typeahead ul').empty();
	},
	    fillList = async function fillList(result) {

		clear();
		cnt.show();
		//RESULTS FROM SEARCH API
		if (result) {

			if (result.hits) {

				if(result.hits.length<=0){
					if(isDarkMode == true){
						var listResult = $('<li class="dark-listResults">No Results.</li>')
					}else{
						var listResult = $('<li class="listResults">No Results.</li>')
					}
					list.append(listResult.on('click', function(e){
						resetAnnotations(false)
						cnt.hide();
						input.val('');
					}));
				}

				if (plotEvents) {
					if (additionalEvents.length < 5) {
						if(TECountry == '' || TECountry== 'Commodity') TECountry = 'United States'
						let url1 = 'https://brains.tradingeconomics.com/v2/search/economy,economic?q='
						let url2 = `&pp=5&mkchart=1&p=${typeaheadNextPage}&_=1566570083316&stance=2&hascalendar=1`
						let response = await fetch(url1 + TECountry.replace(" ", "%20") + url2)
						let result = await response.json()
						if (result) {
							if (result.hits) {
								if (result.hits.length > 0) {
									result.hits.forEach(hit => {
										let containsElem = false
										additionalEvents.forEach(event => {
											if (event.s == hit.s || flagSeriesArr.indexOf(hit.s) > -1){
												containsElem = true
											}
										})
										if(!containsElem){
											additionalEvents.push(hit)
										}
									})

									typeaheadNextPage += 1
								}
							}
						}
					}

					let tempResult = [...result.hits]
					tempResult = tempResult.filter((el) => flagSeriesArr.indexOf(el.s) < 0)

					let i = 0
					while (tempResult.length < 5 && i < additionalEvents.length) {
						let containsElem = false
						tempResult.forEach((item) => {
							if (item.s == additionalEvents[i].s || flagSeriesArr.indexOf(item.s) > -1) {
								containsElem = true
							}
						})
						if (!containsElem){
							tempResult.push(additionalEvents[i])
						}
						i += 1
					}
					// eventsList = [...result.hits]

					eventsList = [...tempResult]
					result.hits = [...tempResult]
					//EPS
					const epsSymbol = TESymbol.trim().toLowerCase() + ':eps'
					TECategory = 'Stock'
					if (TECategory.trim().toLowerCase() == 'stock' && flagSeriesArr.indexOf(epsSymbol) == -1) {
						const epsURL = 'https://brains.tradingeconomics.com/availability/te:markets:' + epsSymbol
						const epsResponse = await fetch(epsURL)
						const epsResponseJSON = await epsResponse.json()
						const epsResult = JSON.parse(epsResponseJSON['resp_body'])

						if (epsResult.found == true) {
							eventsList.unshift({s: epsSymbol, pretty_name: TEAlertsName? TEAlertsName + ' EPS' : TESymbol + ' EPS', name: TEAlertsName? TEAlertsName + ' EPS' : TESymbol + ' EPS'})
							result.hits.unshift({s: epsSymbol, pretty_name: TEAlertsName? TEAlertsName + ' EPS' : TESymbol + ' EPS', name: TEAlertsName? TEAlertsName + ' EPS' : TESymbol + ' EPS'})
						}
					}
				}

				for (var i = 0; i < MAX_ROWS && i < result.hits.length; i++) {
	
					//If the symbol already exists do not suggest it
					var ignoreResult = false;
					for (var symbol of all_serires) {
						if (!plotEvents) {
							if (result && result.hits && result.hits.length && result.hits[i] && result.hits[i].s && result.hits[i].s.toLowerCase() == symbol.s.toLowerCase())
								ignoreResult = true;
						}
					}
					if (result && result.hits && result.hits.length && result.hits[i] && result.hits[i].pretty_name && result.hits[i].pretty_name.toLowerCase().indexOf('indicators') > -1) {
						ignoreResult = true;
					}
					/*if (plotEvents && result.hits[i].pretty_name.indexOf('Indicators') > -1) {
						continue
					}
					if (plotEvents) {
						let existingFlagSeries = flagSeriesArr.find(el => el == result.hits[i].s)
						if (existingFlagSeries != undefined) {
							ignoreResult = true;
						}
					}*/
					if (ignoreResult) continue;

					var row = result.hits[i]
					if(isDarkMode == true){
						var li = $('<li class="dark-listResults"></li>')
					}else{
						var li = $('<li class="listResults"></li>')
					}
						
						li.on('click', function (e) {
							if (plotEvents) {
								saveAnnotationsAfterFlags()
							}
							cnt.hide();
							saveAnnotationsAutomatically(true)
							$('.intVal').hide();
							input.val('');
							isUpdate = false;
							currentSymbol = $(this).children().attr('data-bs').trim();
							checkMetaDataSearch($(this).children().attr('data-bs').trim(), userOptions)//bruno
							var btn = $(".iChart-menu-btn-add");
							$('.compareButtonInput').hide(); btn.addClass('hover-bg-grey').removeClass('hide-input-search');
							$('.header-buttons').show(); $('.iChart-dpMenu-typeahead').hide();
						});

					list.append(li);
					if (!result["default"]) {
						row.context = row.type;
						row.id = row.iids;
						row.importance = 10;
						row.mix = row.name;
						row.name = row.pretty_name;
						row.origin = null;
						row.s = row.s;
						row.search = null;
						row.symbol = row.s;
						row.type = row.type;
						row.url = row.url;
						row.value = row.s;
					}

					/*Typeahead Search Result Setting up here...*/
					var span = $('<div data-bs="' + row.s + '">' + row.name + '</div>');

					li.append(span);

					if (userOptions.addBtns) {
						for (var key in userOptions.addBtns) {
							var btn = userOptions.addBtns[key];

							li.append($('<div class="ta-btn" data-bs="' + row.s + '">' + btn.icon + '</div>').on('click', function (e) {
								cnt.hide();
								input.val('');
								btn.onClick($(this).attr('data-bs'));
							}));
						}
					}
				}

				/*add more button*/
				if (moreNav) {
					list.append($('<li class="iChart-typeahead-more">More</li>').on('click', function (e) {
						cnt.hide();
						moreNav.initializeNavigator();
					}));
				}
			}
		}
	};

	var inputIsHover = false;
	input.hover(function () {
		inputIsHover = true;
	}, function () {
		inputIsHover = false;
	});

	$(document).on('keydown', function (e) {
		e = e || window.event;

		if (cnt.is(':visible')) {

			if (e.keyCode == '38') {
				// up arrow
				e.preventDefault();

				var selected = list.find('li.selected');
				if (selected.length <= 0) {
					list.find('li').last().addClass('selected');
				} else {
					var last = list.find('li.selected').last().removeClass('selected');
					last.prev().addClass('selected');
				}
			} else if (e.keyCode == '40') {
				// down arrow

				e.preventDefault();
				var selected = list.find('li.selected');

				if (selected.length <= 0) {
					list.find('li').first().addClass('selected');
				} else {
					var last = list.find('li.selected').last().removeClass('selected');
					last.next().addClass('selected');
				}
			} else if (e.keyCode == '13') {
				//enter key
				var selected = list.find('li.selected').last();

				e.preventDefault();

				if (selected.length > 0) {
					cnt.hide();
					var _s = selected.children().attr('data-bs');
					if (_s) {
						userOptions.onSelect(_s);
					}

					input.val('');
				}
			} else if (e.keyCode == '27') {
				//escape key
				cnt.hide();
				input.val('');
			}
		}
		if (e.key == 'Escape' && isFS == true) {
			cancelFullScreen();
		}
	});

	input.on('focus', function (e) {
		clearTimeout(timeout);

		if (userOptions.onFocusFill) {
			setTimeout(function () {
				userOptions.onFocusFill.hits = userOptions.onFocusFill;
				userOptions.onFocusFill["default"] = true;
				fillList(userOptions.onFocusFill);
			}, 5);
		} else {
			timeout = setTimeout(call, 5);
		}

		if (userOptions.onFocus) {
			userOptions.onFocus();
		}
	});

	input.on('input', function (e) {
		e.preventDefault();

		clearTimeout(timeout);

		timeout = setTimeout(call, 0);
	});

	$(document).on('click', function (e) {
		if (cnt.is(':visible') && !cnt.is(':hover') && !inputIsHover) {
			if (userOptions.events && userOptions.events.documentClick) {
				userOptions.events.documentClick(cnt, input);
			} else {
				cnt.hide();
				input.val('');
			}
		}
	});
	cnt.append(list);
};